// extracted by mini-css-extract-plugin
export default {"screenContainer":"Note_screenContainer__7HnGM","formContainer":"Note_formContainer__2WXpC","title":"Note_title__t9YkA","text":"Note_text__uUd5d"};